module.exports = __webpack_public_path__ + "static/media/home-style-4.f1ba3de0.svg";